// src/config/api.ts
export const getApiUrl = () => {
  const env = import.meta.env.MODE;
  const envApiUrl = import.meta.env.VITE_API_URL;

  console.log("Environment:", env);
  console.log("Configured API URL:", envApiUrl);

  // Development fallback to HTTP
  if (env === "development") {
    return envApiUrl || "http://localhost:3001/api";
  }

  // Production with SSL validation
  if (env === "production") {
    // Try HTTPS first, fallback if SSL fails
    return envApiUrl || "https://zhdashboardapi.thangthangtechnology.com/api";
  }

  return envApiUrl || "http://localhost:3001/api";
};
